import { Representation } from "@Components/forecast/hourly/NavigationContainer";
import { SnowItem } from "@Components/forecast/hourly/SnowItem";
import { TemperatureItem } from "@Components/forecast/hourly/TemperatureItem";
import { WindItem } from "@Components/forecast/hourly/WindItem";
import { OneHourInterval, ThreeHourInterval } from "@Models/Interval";
import React from "react";

export type HourProps = {
  label: string;
  intervalType: "1h" | "3h";
  hour: OneHourInterval | ThreeHourInterval;
  representation: Representation;
  isLabelBold?: boolean;
  hasDivider?: boolean;
};

export const ItemWrapper = ({
  label,
  intervalType,
  hour,
  representation,
  isLabelBold = false,
  hasDivider = false,
}: HourProps): React.JSX.Element => {
  switch (representation) {
    case "temperature":
      return (
        <TemperatureItem
          label={label}
          intervalType={intervalType}
          hour={hour}
          representation={representation}
          boldLabel={isLabelBold}
          withDivider={hasDivider}
        />
      );
    case "wind":
      return (
        <WindItem
          label={label}
          intervalType={intervalType}
          hour={hour}
          representation={representation}
          boldLabel={isLabelBold}
          withDivider={hasDivider}
        />
      );
    case "snow":
      return (
        <SnowItem
          label={label}
          intervalType={intervalType}
          hour={hour}
          representation={representation}
          boldLabel={isLabelBold}
          withDivider={hasDivider}
        />
      );
  }
};
